<template>
  <v-menu
    v-model="menu[card.id]"
    :disabled="$store.state.isWorkflowDisabled || !cardShownInBacklog"
    style="z-index: 99999;"
    scrim="true"
  >
    <template v-slot:activator="{ props: btnProps}">
      <v-btn
        :id="`select-release-button-${card.id}`"
        v-if="!compact"
        @click="btnProps.onClick($event);"
        variant="outlined"
        size="small"
        :tabindex="tabIndex"
        @keydown="handleKeydown($event, card.id, btnProps.onKeydown)"
        class="status-button release-no"
        :disabled="$store.state.isWorkflowDisabled"
        ref="menuButton"
      >
        <div>
          <template v-if="card.releaseNo">
            {{ getReleaseName(card.releaseNo) }} <v-icon>mds:arrow_drop_down</v-icon>
          </template>
          <template v-else>
            <v-icon class="select-release-for-card" size="small" icon="mdi-dots-horizontal" style="margin-right: 6px;" />
          </template>
        </div>
      </v-btn>
      <v-tooltip
        v-else
        location="bottom"
      >
        <template v-slot:activator="{ on, props }">
          <div
            v-bind="{ ...btnProps, ...props }"
            v-on="{ ...on }"
            :class="{ 'show-on-hover': showOnHover }"
            class="compact-release-no mx-1 px-1"
          >
            {{ card.releaseNo ? 'R' + card.releaseNo : cardShownInBacklog ? '...' : 'N/A'}}
          </div>
        </template>
        <span>{{ cardShownInBacklog ? 'Change release' : 'This card type is hidden from the backlog' }}</span>
      </v-tooltip>
    </template>

    <v-list>
      <v-list-item
        v-for="releaseNo in availableReleases"
        :key="releaseNo"
        @click="changeReleaseNo(card, releaseNo)"
        :active="card.releaseNo === releaseNo"
      >
        <v-list-item-action> {{ getReleaseName(releaseNo) }} </v-list-item-action>
      </v-list-item>
      <v-list-item @click="changeReleaseNo(card, null)">
        <v-list-item-action>
          <v-icon size="small" icon="mds:more-horiz" />
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import workflowApi from '@/api/workflowApi'
import cardHelpers from '@/helpers/cardHelpers'
import midString from '@/utils/mid-string'

export default {
  props: {
    card: Object,
    tabIndex: Number,
    compact: {
      type: Boolean,
      default: false
    },
    showOnHover: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      menu: {}
    }
  },
  computed: {
    ...mapState({
      events: state => state.workflow.workflow.domainEvents,
      workflow: state => state.workflow.workflow,
      cardTypes: state => state.cardTypes.cardTypes
    }),
    ...mapGetters({
      sortedCards: 'workflow/sortedCards'
    }),
    availableReleases () {
      let max = 1
      if (this.events) {
        for (let i = 0; i < this.events.length; i++) {
          for (let j = 0; j < this.events[i].cards?.length; j++) {
            if (this.events[i].cards[j].releaseNo > max) {
              max = this.events[i].cards[j].releaseNo
            }
          }
        }
      }
      return max + 1
    },
    cardShownInBacklog () {
      const cardType = this.cardTypes.find(item => item.id === this.card.cardTypeId)
      return cardType?.showInBacklog
    }
  },
  methods: {
    midString,
    getReleaseName (releaseValue) {
      if (!releaseValue) {
        return 'No release'
      }
      // Check if there's a custom name in the workflow.releases array
      const release = this.workflow?.releases?.find(r => r.value === parseInt(releaseValue))
      if (release && release.name) {
        return release.name
      }
      return 'Release ' + releaseValue
    },
    handleKeydown ($event, cardId, onKeydown) {
      if (this.$store.state.isWorkflowDisabled) return
      // return if escape was pressed
      if ($event.keyCode === 27) {
        this.menu[cardId] = false
        return
      }
      // if key code Enter then don't call the fallback
      if ($event.keyCode === 13) {
        return
      }
      this.$emit('keydown-release-no', $event, cardId, onKeydown)
    },
    async changeReleaseNo (item, releaseNo) {
      if (item.releaseNo === releaseNo) {
        return
      }

      this.menu[item.id] = false
      let previous, next
      const cards = this.sortedCards?.filter(item => item.releaseNo === releaseNo)
      if (cards?.length > 0) {
        if (item.releaseNo === null || (releaseNo !== null && releaseNo < item.releaseNo)) {
          previous = cards[cards.length - 1].sortkey // last card in releaseNo
          next = ''
        } else {
          previous = ''
          next = cards[0].sortkey // first card in releaseNo
        }
      } else {
        previous = ''
        next = ''
      }
      const sortkey = this.midString(previous, next)
      await workflowApi.updateCardsMutation(this.$route.params.id, [{
        cardId: item.id,
        releaseNo,
        sortkey,
        updateNote: {
          action: 'changed release number of',
          target: cardHelpers.getCardTarget(item)
        }
      }])
    }
  }
}
</script>

<style scoped>
.v-btn.status-button {
  padding: 0 0;
  margin-left: 0;
  margin-right: 0;
  min-width: 40px;
}

.add-card-of-type {
  width: 16px;
  height: 16px;
  cursor: move;
}

.compact-release-no {
  font-size: 0.75rem;
  line-height: 1rem;
  border-radius: 8px;
  border: 1px solid #878F99;
}
</style>
